/**
 * RedisTestService
 * Service for testing Redis cache operations
 * Route: api/redistest
 */
import { BaseService } from '../base/BaseService';
export class RedisTestService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? RedisTestService.DEFAULT_SERVICE_PATH,
            basePath: RedisTestService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async setValue(request) {
        const endpoint = this.getEndpoint('set', 'set');
        const url = this.buildUrl(endpoint);
        const response = await this.http.post(url, request);
        if (!response.data)
            throw new Error('No data returned');
        return response.data;
    }
    async getValue(key) {
        const endpoint = this.getEndpoint('get', `get/${key}`);
        const url = this.buildUrl(endpoint);
        const response = await this.http.get(url);
        if (!response.data)
            throw new Error("No data returned");
        return response.data;
    }
    async deleteValue(key) {
        const endpoint = this.getEndpoint('delete', `delete/${key}`);
        const url = this.buildUrl(endpoint);
        const response = await this.http.delete(url);
        if (!response.data)
            throw new Error("No data returned");
        return response.data;
    }
    async ping() {
        const endpoint = this.getEndpoint('ping', 'ping');
        const url = this.buildUrl(endpoint);
        const response = await this.http.get(url);
        if (!response.data)
            throw new Error("No data returned");
        return response.data;
    }
    async setMultiple(requests) {
        const endpoint = this.getEndpoint('set-multiple', 'set-multiple');
        const url = this.buildUrl(endpoint);
        return await this.http.post(url, requests);
    }
    async exists(key) {
        const endpoint = this.getEndpoint('exists', `exists/${key}`);
        const url = this.buildUrl(endpoint);
        const response = await this.http.get(url);
        if (!response.data)
            throw new Error("No data returned");
        return response.data;
    }
    async getExactKey(exactKey) {
        const encodedKey = encodeURIComponent(exactKey);
        const endpoint = this.getEndpoint('get-exact', `get-exact/${encodedKey}`);
        const url = this.buildUrl(endpoint);
        const response = await this.http.get(url);
        if (!response.data)
            throw new Error("No data returned");
        return response.data;
    }
    async getKeys(pattern = '*') {
        const encodedPattern = encodeURIComponent(pattern);
        const endpoint = this.getEndpoint('keys', `keys/${encodedPattern}`);
        const url = this.buildUrl(endpoint);
        const response = await this.http.get(url);
        if (!response.data)
            throw new Error("No data returned");
        return response.data;
    }
}
RedisTestService.DEFAULT_SERVICE_PATH = 'system';
RedisTestService.BASE_PATH = 'api/redistest';
//# sourceMappingURL=RedisTestService.js.map